import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { PathMissingIcon } from '@patternfly/react-icons';
const useStyles = createUseStyles({
    notFoundIcon: { height: '150px', width: '150px' },
});
export const NotFoundIcon = (props) => (_jsx(PathMissingIcon, Object.assign({}, props, { className: useStyles().notFoundIcon })));
export default NotFoundIcon;
